import React from 'react';
import PropTypes from 'prop-types';
import { Editor } from '@tinymce/tinymce-react';

import { TINYMCE_SCRIPT_SRC } from 'data/tinyMce';

export default function RichTextEditor({
  value,
  onChange,
  editorClassName,
  containerClassName,
  placeholder,
  ...remainingProps
}) {
  return (
    <div className={containerClassName}>
      <Editor
        licenceKey="gpl"
        tinymceScriptSrc={TINYMCE_SCRIPT_SRC}
        className={editorClassName}
        onEditorChange={onChange}
        value={value}
        init={{
          height: 'inherit',
          menubar: true,
          placeholder,
          plugins: [
            'advlist',
            'autolink',
            'lists',
            'link',
            'image',
            'charmap',
            'preview',
            'anchor',
            'searchreplace',
            'visualblocks',
            'code',
            'insertdatetime',
            'table',
            'code',
            'wordcount',
          ],
          toolbar:
            'undo redo | blocks | table | bold italic forecolor | ' +
            'alignleft aligncenter alignright alignjustify | ' +
            'bullist numlist outdent indent | removeformat',
          content_style:
            'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
        }}
        {...remainingProps}
      />
    </div>
  );
}

RichTextEditor.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
  containerClassName: PropTypes.string,
};
